import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./SystemFontsList.scss";
import { getFontUrl } from "../../../utils/helpers/common";

interface SystemFontsListProps {
  fonts: any[];
}

const SystemFontsList = ({ fonts }: SystemFontsListProps) => {
  const previewText = "The quick brown fox jumps over the lazy dog";

  useEffect(() => {
    if (!fonts?.length) return;

    const loadedFonts: FontFace[] = [];

    fonts.forEach((data) => {
      const fontUrl = getFontUrl(data);
      if (!fontUrl || fontUrl.includes("pending")) return;

      const uniqueFontName = `system-font-preview-${data?._id}`;

      const alreadyLoaded = Array.from(document.fonts).some(
        (f) => f.family === uniqueFontName,
      );
      if (alreadyLoaded) return;

      try {
        const fontFace = new FontFace(uniqueFontName, `url(${fontUrl})`, {
          weight: "400",
          style: "normal",
          display: "swap",
        });

        fontFace
          .load()
          .then((loaded) => {
            document.fonts.add(loaded);
            loadedFonts.push(loaded);
          })
          .catch((err) => {
            console.warn(`Failed to load font ${uniqueFontName}:`, err);
          });
      } catch (err) {
        console.warn(`FontFace creation failed for ${uniqueFontName}:`, err);
      }
    });

    return () => {
      loadedFonts.forEach((f) => {
        try {
          document.fonts.delete(f);
        } catch {}
      });
    };
  }, [fonts]);

  return (
    <div className="system-fonts-lists">
      {fonts?.map((data) => {
        const fontFamily = data?.font_family || "Poppins";
        const fontUrl = getFontUrl(data);
        const uniqueFontName = `system-font-preview-${data?._id}`;
        const hasValidFont = fontUrl && !fontUrl.includes("pending");

        return (
          <div className="system-font-item" key={data?._id}>
            <div className="font-item-top">
              <h3 className="font-name font-inter-600">{fontFamily}</h3>
              <p className="font-styles-count font-inter-400">
                {data?.styles_count ?? 0} styles
              </p>
            </div>

            <div className="font-preview">
              <p
                className="preview-text"
                style={{
                  fontFamily: hasValidFont
                    ? `'${uniqueFontName}', '${fontFamily}', sans-serif`
                    : `'${fontFamily}', sans-serif`,
                }}
              >
                {previewText}
              </p>
            </div>

            <div className="font-item-footer">
              <Link
                to={`view/${data?._id}`}
                className="view-details-link font-inter-500"
              >
                View details <span className="arrow">→</span>
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SystemFontsList;